import { render, staticRenderFns } from "./recibo-pagamento-escola-ilha.vue?vue&type=template&id=4a85585e&scoped=true&"
import script from "./recibo-pagamento-escola-ilha.vue?vue&type=script&lang=js&"
export * from "./recibo-pagamento-escola-ilha.vue?vue&type=script&lang=js&"
import style0 from "./recibo-pagamento-escola-ilha.vue?vue&type=style&index=0&id=4a85585e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a85585e",
  null
  
)

export default component.exports